export default {
  list: { lazy: () => import('./GlobalProjects'), component: 'GlobalProjectList' },
}
